import { Texture } from '@babylonjs/core/Materials/Textures/texture';
import clone from 'lodash/clone';

import { IDecalParameters, IVariantDecal, PatternDecal } from './patternDecal';

export interface IVariantMask extends IVariantDecal {
    material?: string,
    mask: string,
}

export interface IMaskGeometry extends IDecalParameters {
    maskList?: string[],
}

export class PatternMask extends PatternDecal {
    protected maskGeometry: IMaskGeometry

    protected currentVariant: IVariantMask = {}

    public setGeometry(maskGeometry: IMaskGeometry): void {
        this.maskGeometry = maskGeometry;
        this.currentVariant = {
            name: maskGeometry.name,
            type: 'mask',
            mask: '',
        };
        if (maskGeometry.maskList !== undefined) this.setMaskList(maskGeometry.maskList);
        this.setDecalGeometry(maskGeometry);
    }

    getGeometry(): IMaskGeometry {
        return clone(this.maskGeometry);
    }

    private setMaskList(maskList: string[]) {
        this.maskGeometry.maskList = maskList;
        this.setMask(maskList[0]);
    }

    public getMaskList(): string[] {
        return this.maskGeometry.maskList;
    }

    public setMask(mask: string): void {
        this.currentVariant.mask = mask;
        this._system.loader.loadTexture(mask, 'decal_mask', (success, task) => {
            if (success) {
                this.setMaskTexture(task.texture);
                this.resetDecalGeometry();
            }
        });
    }

    private setMaskTexture(texture: Texture) {
        texture.hasAlpha = true;
        texture.wrapU = Texture.CLAMP_ADDRESSMODE;
        texture.wrapV = Texture.CLAMP_ADDRESSMODE;
        this.material.albedoTexture = texture;
        this.material.opacityTexture = texture;
        this.setDecalSize(this.geometry.size);
        this.setDecalRotation(this.geometry.rotation);
        this.updateDecal();
    }

    public setVariant(variant: IVariantMask): void {
        this.setMask(variant.mask);
    }

    public resetVariant(): void {
        this.material.albedoTexture = null;
        this.material.opacityTexture = null;
    }
}
